/**
 * Removes US/UK-style thousands commas from displayed money strings (e.g. $1,234.56 → $1234.56).
 * Runs on load and on DOM updates (variant changes, cart, section morphing).
 *
 * Not suitable for locales where comma is the decimal separator (e.g. 12,50 €); disable in that case.
 */
(function () {
  'use strict';

  /**
   * @param {string} str
   * @returns {string}
   */
  function stripThousandsCommas(str) {
    if (!str || typeof str !== 'string' || !str.includes(',')) return str;
    let out = str;
    let prev;
    do {
      prev = out;
      // One ASCII comma between one digit and exactly three more digits (thousands grouping)
      out = out.replace(/(\d),(\d{3})(?=\d*(\D|$))/g, '$1$2');
    } while (out !== prev);
    return out;
  }

  /**
   * @param {Text} textNode
   */
  function processTextNode(textNode) {
    const t = textNode.nodeValue;
    if (!t || !t.includes(',')) return;
    const next = stripThousandsCommas(t);
    if (next !== t) textNode.nodeValue = next;
  }

  /**
   * @param {HTMLElement | Element} el
   */
  function walkElement(el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      const current = node;
      node = walker.nextNode();
      processTextNode(/** @type {Text} */ (current));
    }
  }

  /** Containers that commonly hold theme-rendered money strings */
  const ROOT_SELECTORS = [
    'product-price',
    '.price',
    '.compare-at-price',
    '.cart-totals__original-value',
    '.cart-totals__total-value',
    '.cart-discounts__value',
    '.cart-items__price',
    '.sticky-add-to-cart__price',
    '.unit-price',
    '.price-per-item__text',
    '.volume-pricing-info__price',
    '.hotspot-dialog__product-price',
    '.variant-item__mobile-price',
    '.variant-item__total-price',
    '.quick-order-list-total__price',
    '.gift-card__price',
  ].join(',');

  let scheduled = false;

  function run() {
    scheduled = false;
    try {
      document.querySelectorAll(ROOT_SELECTORS).forEach((el) => walkElement(el));
    } catch (_) {
      // Older browsers — ignore
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const obs = new MutationObserver(schedule);
  if (document.documentElement) {
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
})();
